import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";

import { useAuth } from "~/auth/auth-context";

// Gates a route on authentication. While Firebase is still hydrating, shows a
// spinner rather than flashing the login screen; once settled, either renders
// the route or bounces an anonymous visitor to /login (preserving where they
// were headed via ?next).
export function ProtectedRoute({ children }: { children: ReactNode }): JSX.Element {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-svh items-center justify-center bg-background">
        <Loader2
          className="h-6 w-6 animate-spin text-muted-foreground"
          role="status"
          aria-label="Loading"
        />
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
